import { Account } from "@arelia-types/index";
import { useMutation, useQuery } from "react-query";
import { http } from "src/api/http";
import { EditForm } from "./CaptureFormContainer";

export function usePublicAccoutDataAPI(publicId: string) {
  return useQuery<Account>({
    queryKey: ["usePublicAccoutDataAPI"],
    queryFn: () => http(`/api/account/public/${publicId}`)
  });
}

export function usePostCaptureForm(publicId: string, setSubmitted: (submitted: boolean) => void){
  return useMutation({
    mutationFn: (body: EditForm) => http(`/api/my-fans/${publicId}/form`, {
      method: "POST",
      body
    }),
    onSuccess: () => {
      setSubmitted(true);
    }
  });
}